import React from 'react';
import { STATUS_STYLES, ownerInitials } from './helpers';

export const StatusPill: React.FC<{ status?: string | null }> = ({ status }) => {
  const key = (status ?? 'UNKNOWN').toUpperCase();
  const s = STATUS_STYLES[key] ?? { badge: 'bg-gray-100 text-gray-600 ring-gray-500/20', dot: 'bg-gray-400' };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ring-1 ring-inset ${s.badge}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {key}
    </span>
  );
};

export const MetaItem: React.FC<{ icon: React.ElementType; label: string; value: React.ReactNode }> = ({
  icon: Icon,
  label,
  value,
}) => (
  <div className="flex items-start gap-2.5">
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
    <div className="min-w-0">
      <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">{label}</p>
      <div className="truncate text-sm text-gray-800">{value}</div>
    </div>
  </div>
);

export const OwnerValue: React.FC<{ owner: any; oid?: unknown; uid?: unknown }> = ({ owner, oid, uid }) => {
  if (!owner) return <>{oid ? `org ${oid}` : uid ? `uid ${uid}` : '—'}</>;
  const name = [owner.first_name, owner.last_name].filter(Boolean).join(' ') || `uaid ${owner.uaid}`;
  return (
    <div className="flex items-center gap-2">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-indigo-100 text-[11px] font-semibold text-indigo-700">
        {ownerInitials(owner)}
      </span>
      <div className="min-w-0">
        <p className="truncate text-sm font-medium text-gray-900" title={name}>{name}</p>
        {owner.email && (
          <a
            href={`mailto:${owner.email}`}
            className="block truncate text-xs text-indigo-500 hover:underline"
            title={owner.email}
          >
            {owner.email}
          </a>
        )}
      </div>
    </div>
  );
};
